const Raiz = ({ text = "Comenzar Ahora", onClick }) => {
  return (
    <button className="cta-button roots-fill" onClick={onClick}>
      <span>{text}</span>
    </button>
  );
};

export default Raiz;